export default __webpack_public_path__ + "static/media/control.e0041464.webp";